import { FiAlertCircle } from 'react-icons/fi'

import { t } from 'i18next'
import moment from 'moment'

import Tooltip from '~/components/Tooltip'

import { ROAS_CUTOFF_DATE } from '../../constants'

export function ClickCutoffAlertIcon() {
  const date = moment(ROAS_CUTOFF_DATE, 'DD/MM/YYYY').format(
    t('c:patterns.date')
  )
  return (
    <span
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    >
      <Tooltip noMargin text={t('rm:alerts.clickCutoff', { date })}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#d99a2b',
            height: '100%'
          }}
        >
          <FiAlertCircle size={13} />
        </span>
      </Tooltip>
    </span>
  )
}
